import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Video from "react-responsive-video";
import TempoVideo from "../../video/Centers-hero.MOV";
import AOS from 'aos';
import 'aos/dist/aos.css';
import "../../styles/Centers.css";

// For SocMeds Icons
// Use only the free-solid-svg-icons package
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faGlobe } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faInstagram, faTiktok } from '@fortawesome/free-brands-svg-icons';

function CentersHome() {
  const [activeCenter, setActiveCenter] = useState("sports");
  const location = useLocation();

  const scrollToNav = () => {
    const navElement = document.querySelector(".centers-nav-wrapper");
    if (navElement) {
      const offset = 80; // Adjust based on your header height
      const elementPosition = navElement.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: elementPosition - offset,
        behavior: "smooth",
      });
    }
  };

  // URL Sync Logic
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const type = params.get("type");
    if (type) {
      setActiveCenter(type);
      const timer = setTimeout(() => {
        const navElement = document.querySelector(".centers-nav-wrapper");
        if (navElement) {
          const offset = 80;
          const elementPosition = navElement.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({ top: elementPosition - offset, behavior: "smooth" });
        }
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [location]);

  // AOS Refresh Logic
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: false,
      mirror: false
    });
    AOS.refresh();
  }, [activeCenter]);

  // Content Data
  const centerData = {
    sports: [
      { id: 1, title: "Basketball Court", img: "/vscimages/facilities/basket2.jpg", desc: "A regulation-size court with quality flooring and professional lighting, ideal for training, league matches, and recreational games." },
      { id: 2, title: "Badminton", img: "/vscimages/facilities/Badminton Court.jpg", desc: "A professional badminton court with regulation dimensions and optimal lighting, perfect for training, competitive matches, and recreational play." },
      { id: 3, title: "Tennis Court", img: "/vscimages/facilities/Tennis Court.jpg", desc: "Premium tennis courts designed for training, competitive matches, and recreational rallies for players of all skill levels." },
      { id: 4, title: "Boxing Gym", img: "/vscimages/facilities/Boxing Gym.jpg", desc: "A fully equipped training space for boxing workouts, skill development, and conditioning." },
      { id: 5, title: "MMA Area", img: "/vscimages/facilities/MMA Gym.jpg", desc: "A dedicated space for mixed martial arts training, grappling, and combat conditioning." },
      { id: 6, title: "Bowling Alley", img: "/vscimages/facilities/Bowling Alley.jpg", desc: "A modern bowling area perfect for friendly games, competitions, and social gatherings." },
    ],

    fitness: [
      { id: 1, title: "Main Gym", img: "/vscimages/facilities/Gym.jpg", desc: "A complete fitness center with modern equipment for strength training, cardio, and overall fitness." },
      { id: 2, title: "Private Gym", img: "/vscimages/facilities/Private Gym.jpg", desc: "An exclusive workout space offering privacy and a more personalized training environment." },
    ],
    
     wellness: [
      { id: 1, title: "Water Spa", img: "/vscimages/facilities/Water Spa.jpg", desc: "A relaxing hydrotherapy space with temperature-controlled pools and water jets that help relieve muscle tension, improve circulation, and promote recovery." },
      { id: 2, title: "Lap Pool", img: "/vscimages/facilities/Lap pool.jpg", desc: "A competition-standard pool designed for training, lap swimming, and aquatic fitness. Ideal for athletes and members seeking a refreshing and performance-focused swimming experience." },
       { id: 3, title: "Jacuzzi", img: "/vscimages/facilities/Jacuzzi.jpg", desc: "A relaxing heated pool designed to ease muscle tension and promote recovery." },
      { id: 4, title: "Sauna", img: "/vscimages/facilities/suana1.jpg", desc: "A soothing heat therapy space that helps improve circulation, detoxify the body, and support relaxation." },
    
      
    ],

    lifestyle: [
      { id: 1, title: "VS Hotel", 
        img: "/vscimages/facilities/hotel.jpg", 
        desc: "Experience luxury and comfort right within the heart of the sports complex.", 
          contacts: {
          phone: "+63917 825 9938",
          website: "https://vshotel.com.ph",
          fb: "https://www.facebook.com/vshotelph",
          ig: "https://www.instagram.com/vshotelph/",
          tiktok: "https://www.tiktok.com/@vshotelph",
        }
       },
       { id: 2, title: "VS TO GO", 
        img: "/vscimages/facilities/togo.jpg", 
        desc: "Fuel your active lifestyle with a curated selection of gourmet meals, artisan refreshments, and healthy snacks designed for quality on the go", 
        contacts: {
          phone: "+63 945 461 5200",
          website: "https://www.vshotel.com.ph/vstogo",
          
        }
       },
      { id: 3, title: "Victoria Skin", 
        img: "/vscimages/facilities/skin.jpg", 
        desc: "Relax and rejuvenate with our premium skincare and wellness services.", 
        contacts: {
          phone: "+63 966 877 8825",
          website: "https://www.vshotel.com.ph/vskin",
          fb: "https://www.facebook.com/victoriaskinofficial",
          ig: "https://www.instagram.com/victoriaskinofficial/",
          tiktok: "https://www.tiktok.com/@victoriaskinofficial",
        }
       },
      { id: 4, title: "Victoria Sports Cinema", 
        img: "/vscimages/facilities/cinema-vsc.jpg", 
        desc: "A private screening space with Lazy Boy recliners and advanced audio-visual technology, perfect for movies, sports viewings, and special events.", 
        contacts: {
          phone: "+63 912 345 6789",
          website: "https://www.victoriasportsclub.com/cinema",
          fb: "https://www.facebook.com/VictoriaSportsCinema",
          ig: "https://www.instagram.com/victoriasportscinema/",
          tiktok: "https://www.tiktok.com/@victoriasportscinema",
        }
       },
    ],

    programs: [
      { id: 1, title: "Mixed Martial Arts", 
        img: "/vscimages/facilities/MMA Gym.jpg", 
        desc: "A structured training program designed to develop strength, discipline, and mixed martial arts techniques.",
        contacts: {
            phone: "+63 912 345 6789",
            fb: "https://www.facebook.com/VictoriaSportsCinema",
            ig: "https://www.instagram.com/victoriasportscinema/",
            tiktok: "https://www.tiktok.com/@victoriasportscinema",
          }
        },
      { id: 2, title: "Zumba Class", img: "/vscimages/offers/zumba.jpg", desc: "A fun and energetic dance workout that combines music and fitness for a full-body cardio session." },
      { id: 3, title: "Yoga Class", img: "/vscimages/offers/yoga.jpg", desc: "A calming class focused on flexibility, balance, and mindfulness through guided yoga movements." },
      { id: 4, title: "Spinning Class", img: "/vscimages/offers/sinning.jpg", desc: "A calming class focused on flexibility, balance, and mindfulness through guided yoga movements." },
      { id: 5, title: "HIIT Class", img: "/vscimages/offers/hiit.jpg", desc: "A fast-paced workout using short bursts of intense exercise to maximize fat burn and build strength." },
      
    ]
  };

  

  return (
    <>
      <div className='centerspage-wrap'>
            <div className='centers-vid'>
                {/**<Video mp4={vsclubvid} /> */}
                <Video mp4={TempoVideo} />

                <div className="centers-hero-overlay">
                  <div className="centers-hero-text-box" data-aos="fade-up">
                    <h1>Experience the Gold Standard of Urban Living</h1>
                   {/* Added onClick here */}
                    <button className="centers-explore-btn" onClick={scrollToNav}>
                      Explore Now
                    </button>
                    
                    <div className="centers-scroll-indicator" onClick={scrollToNav} style={{ cursor: 'pointer' }}>
                      <div className="centers-mouse">
                        <div className="centers-wheel"></div>
                      </div>
                      <div className="centers-arrow-scroll">
                        <span className="centers-down-arrow"></span>
                        <span className="centers-down-arrow"></span>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
        </div>

      <div className="centers-nav-wrapper">
        <div className="centers-nav">
          {["sports", "fitness", "wellness", "lifestyle", "programs"].map((tab) => (
            <button
              key={tab}
              className={activeCenter === tab ? "active" : ""}
              onClick={() => setActiveCenter(tab)}
            >
              {tab.charAt(0).toUpperCase() + tab.slice(1)}
            </button>
          ))}
        </div>
      </div>

      <div key={activeCenter} className="centers-container fade-center">
        {centerData[activeCenter].map((item, index) => (
          <div
            key={item.id}
            className={`center-card ${index % 2 !== 0 ? 'reverse' : ''}`}
            data-aos={index % 2 === 0 ? 'fade-right' : 'fade-left'}
            data-aos-duration="1000"
            data-aos-easing="ease-in-out"
            data-aos-delay="100"
            data-aos-once="false"
          >
            {/* Look for this section in your map function */}
            <div className="center-img">
              <img 
                src={item.img} 
                alt={item.title} 
                /* Add a conditional class here */
                className={activeCenter === "programs" && item.id >= 2 ? "portrait-img" : ""} 
              />
            </div>

           <div className="center-text">
              <h2>{item.title}</h2>
              <p>{item.desc}</p>

              {/* NEW CONTACT SECTION */}
                {item.contacts && (
                  /* Dynamic class added here: if index is 0 or 2, add 'white-text' */
                  <div className={`center-contact-info ${index % 2 === 0 ? 'white-text' : ''}`}>
                    <div className="contact-links">
                      {item.contacts.phone && (
                        <div 
                          className="contact-item" 
                          onClick={() => window.location.href = `tel:${item.contacts.phone}`}
                          style={{ cursor: 'pointer' }}
                        >
                          <FontAwesomeIcon icon={faPhone} /> 
                          <span>{item.contacts.phone}</span>
                        </div>
                      )}
                    </div>

                    <div className="social-links">
                      {/* Website - Only show if it exists */}
                      {item.contacts.website && (
                        <a href={item.contacts.website} target="_blank" rel="noreferrer" title="Visit Website">
                          <FontAwesomeIcon icon={faGlobe} />
                        </a>
                      )}

                      {/* Facebook - Only show if it exists */}
                      {item.contacts.fb && (
                        <a href={item.contacts.fb} target="_blank" rel="noreferrer" title="Facebook">
                          <FontAwesomeIcon icon={faFacebookF} />
                        </a>
                      )}

                      {/* Instagram - Only show if it exists */}
                      {item.contacts.ig && (
                        <a href={item.contacts.ig} target="_blank" rel="noreferrer" title="Instagram">
                          <FontAwesomeIcon icon={faInstagram} />
                        </a>
                      )}

                      {/* TikTok - Only show if it exists */}
                      {item.contacts.tiktok && (
                        <a href={item.contacts.tiktok} target="_blank" rel="noreferrer" title="TikTok">
                          <FontAwesomeIcon icon={faTiktok} />
                        </a>
                      )}
                    </div>
                  </div>
                )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

export default CentersHome;